import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import React from 'react'
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const RegisterCompany = ({ formik, formik2, signInPassword, codeSend, setCodeSend }) => {

    const { t } = useTranslation()

    if (codeSend) {
        return (
            <>
                <div className='col-12'>
                    <FormGroup
                        id='code'
                        isFloating
                        label={t("login.code")}
                        className={classNames({
                            'd-none': signInPassword,
                        })}>
                        <Input
                            autoComplete='code'
                            type="number"
                            value={formik2.values.code}
                            isTouched={formik2.touched.code}
                            invalidFeedback={
                                formik2.errors.code
                            }
                            isValid={formik2.isValid}
                            onChange={formik2.handleChange}
                            onBlur={formik2.handleBlur}
                            onFocus={() => {
                                formik2.setErrors({});
                            }}

                        />
                    </FormGroup>
                </div>
                <div className='col-12'>
                    <FormGroup
                        id='password'
                        isFloating
                        label={t("common.password")}
                        className={classNames({
                            'd-none': signInPassword,
                        })}>
                        <Input
                            autoComplete='password'
                            type="password"
                            value={formik2.values.password}
                            isTouched={formik2.touched.password}
                            invalidFeedback={
                                formik2.errors.password
                            }
                            isValid={formik2.isValid}
                            onChange={formik2.handleChange}
                            onBlur={formik2.handleBlur}
                            onFocus={() => {
                                formik2.setErrors({});
                            }}
                        />
                    </FormGroup>
                </div>
                <div className='col-12'>
                    <FormGroup
                        id='passwordRepeat'
                        isFloating
                        label={t("common.passwordRepeat")}
                        className={classNames({
                            'd-none': signInPassword,
                        })}>
                        <Input
                            autoComplete='passwordRepeat'
                            type="password"
                            value={formik2.values.passwordRepeat}
                            isTouched={formik2.touched.passwordRepeat}
                            invalidFeedback={
                                formik2.errors.passwordRepeat
                            }
                            isValid={formik2.isValid}
                            onChange={formik2.handleChange}
                            onBlur={formik2.handleBlur}
                            onFocus={() => {
                                formik2.setErrors({});
                            }}
                        />
                    </FormGroup>
                </div>
                <div className='col-12'>
                    <Button
                        color='info'
                        className='w-100 py-3'
                        onClick={formik2.handleSubmit}>
                        {t("common.submit")}
                    </Button>
                    <Button
                        color='danger'
                        className='w-100 py-3 mt-2'
                        onClick={() => setCodeSend(!codeSend)}>
                        {t("common.takeBack")}
                    </Button>
                </div>
            </>
        )
    }

    return (
        <>
            <div className='col-12'>
                <FormGroup
                    id='companyName'
                    isFloating
                    label={t("common.companyName")}
                    className={classNames({
                        'd-none': signInPassword,
                    })}>
                    <Input
                        autoComplete='companyName'
                        value={formik.values.companyName}
                        isTouched={formik.touched.companyName}
                        invalidFeedback={
                            formik.errors.companyName
                        }
                        isValid={formik.isValid}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onFocus={() => {
                            formik.setErrors({});
                        }}
                    />
                </FormGroup>
            </div>
            <div className='col-12'>
                <FormGroup
                    id='firstname'
                    isFloating
                    label={t("common.name")}
                    className={classNames({
                        'd-none': signInPassword,
                    })}>
                    <Input
                        autoComplete='firstname'
                        value={formik.values.firstname}
                        isTouched={formik.touched.firstname}
                        invalidFeedback={
                            formik.errors.firstname
                        }
                        isValid={formik.isValid}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onFocus={() => {
                            formik.setErrors({});
                        }}
                    />
                </FormGroup>
            </div>
            <div className='col-12'>
                <FormGroup
                    id='familyname'
                    isFloating
                    label={t("common.surname")}
                    className={classNames({
                        'd-none': signInPassword,
                    })}>
                    <Input
                        autoComplete='familyname'
                        value={formik.values.familyname}
                        isTouched={formik.touched.familyname}
                        invalidFeedback={
                            formik.errors.familyname
                        }
                        isValid={formik.isValid}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onFocus={() => {
                            formik.setErrors({});
                        }}
                    />
                </FormGroup>
            </div>
            <div className='col-12'>
                <FormGroup
                    id='email'
                    isFloating
                    label={t("common.email")}
                    className={classNames({
                        'd-none': signInPassword,
                    })}>
                    <Input
                        autoComplete='email'
                        value={formik.values.email}
                        isTouched={formik.touched.email}
                        invalidFeedback={
                            formik.errors.email
                        }
                        isValid={formik.isValid}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        onFocus={() => {
                            formik.setErrors({});
                        }}
                    />
                </FormGroup>
            </div>
            <div className='col-12'>
                <Button
                    color='info'
                    className='w-100 py-3'
                    onClick={formik.handleSubmit}>
                    {t("common.save")}
                </Button>
            </div>
        </>
    )
}

export default RegisterCompany